import React from 'react';
import QuestionnaireWizard from '../components/questionnaire/QuestionnaireWizard';

export default function QuestionnairePage() {
  return <QuestionnaireWizard />;
}